export default __webpack_public_path__ + "static/RolesAndResponsibilities-0f18229e7c54bce15bffe0ac6bf261be.png";